const { default: axiosInstance } = require('../axiosInstance');

const removeTeamFromEvent = async (eventId, teamId) => {
  return axiosInstance.delete(`/team/remove/${eventId}/${teamId}`).then((response) => {
    return response.data;
  });
};

const updateTeamStatus = async (eventId, teamId, status, reason) => {
  return axiosInstance
    .put(`/team/status/${eventId}/${teamId}`, { status, reason })
    .then((response) => {
      return response.data;
    });
};

const teamService = {
  removeTeamFromEvent,
  updateTeamStatus
};

export default teamService;
